import { Stack } from "@bvhi/ui-base";
import { NavigationBar } from "../../../../components/navigation-bar";
import { MessagesInfoDetailsCard } from "./components/message-info-details.card";
import { MessagesResendMessagesCard } from "./components/message-resend-messages.card";
import { MessagesTestMessageCard } from "./components/message-test-message.card";

export const MessagesInfoView = () => {
  // TODO: stalled messages resend should be disabled if the user does not have any stalled messages
  return (
    <>
      <NavigationBar showBreadcrumbs={true} />
      <Stack pt={2} spacing={2}>
        <MessagesInfoDetailsCard />
        <MessagesTestMessageCard />
        <MessagesResendMessagesCard />
      </Stack>
    </>
  );
};
